import { render, staticRenderFns } from "./PerformanceAttributionDetail.vue?vue&type=template&id=133a271c&scoped=true&"
import script from "./PerformanceAttributionDetail.vue?vue&type=script&lang=js&"
export * from "./PerformanceAttributionDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "133a271c",
  null
  
)

export default component.exports